export default {"src":"/_next/static/media/vk-mail.26d7d451.svg","height":40,"width":41,"blurWidth":0,"blurHeight":0};